/* eslint-env browser */
import axios from 'axios';
import { BASE_URL } from '../components/Constant';

//get all the employee qualification
function getOfficeInfo(officePayload) {
  const endpoint = BASE_URL + 'officeInfo/getOfficeInfo';
  return axios.post(endpoint, officePayload, {
    headers: {
      // eslint-disable-next-line no-undef
      authorization: `${localStorage.getItem('token')}`
    }
  });
}

//create or update employee qualification
function createOfficeInfo(officeData) {
  const endpoint = BASE_URL + 'officeInfo/createOfficeInfo';
  return axios.post(endpoint, officeData, {
    headers: {
      // eslint-disable-next-line no-undef
      authorization: `${localStorage.getItem('token')}`
    }
  });
}

//create or update employee qualification
function updateOfficeInfo(officeData) {
  const endpoint = BASE_URL + 'officeInfo/updateOfficeInfo';
  const payload = new FormData();
  Object.entries(officeData).forEach(([key, value]) => {
    if (value !== undefined && value !== null) payload.append(key, value);
  });

  return axios.put(endpoint, payload, {
    headers: {
      // eslint-disable-next-line no-undef
      authorization: `${localStorage.getItem('token')}`,
      'Content-Type': 'multipart/form-data'
    }
  });
}

//fetch access level records
function officeAccessLevels() {
  const endpoint = BASE_URL + 'officeInfo/officeAccessLevels';
  return axios.get(endpoint, {
    headers: {
      // eslint-disable-next-line no-undef
      authorization: `${localStorage.getItem('token')}`
    }
  });
}

//update user access level
function updateUserOfficeAccessLevel(usrAccessLevelObj) {
  const endpoint = BASE_URL + 'officeInfo/userOfficeAccessLevel';
  return axios.put(
    endpoint,
    {
      usrAccessLevelObj: usrAccessLevelObj
    },
    {
      headers: {
        // eslint-disable-next-line no-undef
        authorization: `${localStorage.getItem('token')}`
      }
    }
  );
}

//get user protege id from officeInfo table if available, if not from protege controller
function protegeUserDetails(userObj) {
  const endpoint = BASE_URL + 'officeInfo/protegeUserDetails';
  return axios.get(endpoint, {
    params: {
      employeeId: userObj.employeeId
    },
    headers: {
      // eslint-disable-next-line no-undef
      authorization: `${localStorage.getItem('token')}`
    }
  });
}

//get employees pin codes
function employeesPinCode() {
  const endpoint = BASE_URL + 'officeInfo/employeesPinCode';
  return axios.get(endpoint, {
    headers: {
      // eslint-disable-next-line no-undef
      authorization: `${localStorage.getItem('token')}`
    }
  });
}

const officeInfoService = {
  getOfficeInfo,
  createOfficeInfo,
  updateOfficeInfo,
  officeAccessLevels,
  updateUserOfficeAccessLevel,
  protegeUserDetails,
  employeesPinCode
};

export default officeInfoService;
